import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  container: constants.Colors.DarkBlue,
  note: '#fff',
  divider: '#040628'
};
